import { render, staticRenderFns } from "./AddOrHandle.vue?vue&type=template&id=7446e7c4&scoped=true"
import script from "./AddOrHandle.vue?vue&type=script&lang=js"
export * from "./AddOrHandle.vue?vue&type=script&lang=js"
import style0 from "./AddOrHandle.vue?vue&type=style&index=0&id=7446e7c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7446e7c4",
  null
  
)

export default component.exports